<template>
  <div>
    <base-header class="pb-6 pb-7 pt-5 pt-md-6 bg-gradient-success">
    </base-header>
    <b-container fluid class="mt--7">
      <b-row>
        <b-col xl="4" md="6">
          <b-card
            title="予測因子"
            type="gradient-orange"
            icon="ni ni-chart-pie-35"
            class="mb-2 "
          >
            <b-card-body>
              <div class="row align-items-center mt-n5">
                <label for="" class="col-sm-4 col-form-label"></label>
                <div class="col-sm-6"></div>
                <div class="col-sm-2 align-items-left">
                  <small class="h text-muted ">不明 </small>
                </div>
              </div>
              <div class="row mb-1 align-items-center">
                <label for="" class="col-sm-4 col-form-label">年齢</label>
                <div class="col-sm-6">
                  <div class="input-group">
                    <input
                      type="number"
                      class="form-control"
                      id=""
                      placeholder=""
                      v-model="exams.Age"
                      v-on:blur="onExamUpdated"
                    />
                    <div class="input-group-append">
                      <span class="input-group-text">歳</span>
                    </div>
                  </div>
                </div>
                <div class="col-sm-1">
                  <b-form-checkbox
                    class="mb-1 mr-sm-2 mb-sm-2"
                  ></b-form-checkbox>
                </div>
              </div>
              <div class="row mb-1 align-items-center">
                <label for="" class="col-sm-4 col-form-label">性別</label>
                <div class="col-sm-6">
                  <b-form-select
                    id="inline-form-custom-select-pref"
                    :options="[
                      { text: '不明', value: null },
                      { text: '男性', value: 1 },
                      { text: '女性', value: 0 }
                    ]"
                    :value="null"
                    v-model="exams.Gender"
                    v-on:blur="onExamUpdated"
                  ></b-form-select>
                </div>
              </div>
              <div class="row mb-1 align-items-center">
                <label for="" class="col-sm-4 col-form-label">高血圧</label>
                <div class="col-sm-6">
                  <b-form-select
                    id="inline-form-custom-select-pref"
                    :options="[
                      { text: '不明', value: null },
                      { text: '有', value: 1 },
                      { text: '無', value: 0 }
                    ]"
                    :value="null"
                    v-model="exams.Hypertension"
                  ></b-form-select>
                </div>
              </div>
              <div class="row mb-1 align-items-center">
                <label for="" class="col-sm-4 col-form-label">糖尿病</label>
                <div class="col-sm-6">
                  <b-form-select
                    id="inline-form-custom-select-pref"
                    :options="[
                      { text: '不明', value: null },
                      { text: '有', value: 1 },
                      { text: '無', value: 0 }
                    ]"
                    :value="null"
                    v-model="exams.Diabetes"
                  ></b-form-select>
                </div>
              </div>
              <div class="row mb-1 align-items-center">
                <label for="" class="col-sm-4 col-form-label">血清Cre</label>
                <div class="col-sm-6">
                  <div class="input-group">
                    <input
                      type="number"
                      class="form-control"
                      id=""
                      placeholder=""
                      v-model="exams.Serum_Creatinine"
                      v-on:blur="onExamUpdated"
                    />
                    <div class="input-group-append">
                      <span class="input-group-text">mg/dL</span>
                    </div>
                  </div>
                </div>
                <div class="col-sm-1">
                  <b-form-checkbox class="mr-sm-2 mb-sm-2"></b-form-checkbox>
                </div>
              </div>
              <div class="row mb-1 align-items-center">
                <label for="" class="col-sm-4 col-form-label">eGFR</label>
                <div class="col-sm-6">
                  <div class="input-group">
                    <input
                      type="number"
                      class="form-control"
                      id=""
                      placeholder=""
                      v-model="exams.Baseline_eGFR"
                    />
                    <div class="input-group-append">
                      <span class="input-group-text"
                        >mL/m/1.73m<sup>2</sup></span
                      >
                    </div>
                  </div>
                </div>
                <div class="col-sm-1 align-items-right">
                  <b-form-checkbox class="mr-sm-2 mb-sm-2"></b-form-checkbox>
                </div>
              </div>
              <div class="row mb-1 align-items-center">
                <label for="" class="col-sm-4 col-form-label">血漿Alb</label>
                <div class="col-sm-6">
                  <div class="input-group">
                    <input
                      type="number"
                      class="form-control"
                      id=""
                      placeholder=""
                      v-model="exams.Plasma_Albumin"
                    />
                    <div class="input-group-append">
                      <span class="input-group-text">g/dL</span>
                    </div>
                  </div>
                </div>
                <div class="col-sm-1">
                  <b-form-checkbox class="mr-sm-2 mb-sm-2"></b-form-checkbox>
                </div>
              </div>

              <div class="row mb-1 align-items-center">
                <label for="" class="col-sm-4 col-form-label">血清Na</label>
                <div class="col-sm-6">
                  <div class="input-group">
                    <input
                      type="number"
                      class="form-control"
                      id=""
                      placeholder=""
                      v-model="exams.Serum_Sodium"
                    />
                    <div class="input-group-append">
                      <span class="input-group-text">mEq/L</span>
                    </div>
                  </div>
                </div>
                <div class="col-sm-1">
                  <b-form-checkbox class="mr-sm-2 mb-sm-2"></b-form-checkbox>
                </div>
              </div>
              <div class="row mb-1 align-items-center">
                <label for="" class="col-sm-4 col-form-label">血清K</label>
                <div class="col-sm-6">
                  <div class="input-group">
                    <input
                      type="number"
                      class="form-control"
                      id=""
                      placeholder=""
                      v-model="exams.Serum_Potassium"
                    />
                    <div class="input-group-append">
                      <span class="input-group-text">mEq/L</span>
                    </div>
                  </div>
                </div>
                <div class="col-sm-1">
                  <b-form-checkbox class="mr-sm-2 mb-sm-2"></b-form-checkbox>
                </div>
              </div>
              <div class="row mb-1 align-items-center">
                <label for="" class="col-sm-4 col-form-label">尿蛋白定性</label>
                <div class="col-sm-6">
                  <div class="input-group">
                    <b-form-select
                      id="inline-form-custom-select-pref"
                      :options="[
                        { text: '不明', value: null },
                        { text: '(+)', value: 1 },
                        { text: '(-)', value: 0 }
                      ]"
                      :value="null"
                      v-model="exams.UP_Qualitative"
                    ></b-form-select>
                  </div>
                </div>
                <div class="col-sm-1">
                  <b-form-checkbox class="mr-sm-2 mb-sm-2"></b-form-checkbox>
                </div>
              </div>
              <div class="row mb-1 align-items-center">
                <label for="" class="col-sm-4 col-form-label">尿蛋白定量</label>
                <div class="col-sm-6">
                  <div class="input-group">
                    <input
                      type="number"
                      class="form-control"
                      id=""
                      placeholder=""
                      v-model="exams.UP_Quantitative"
                    />
                    <div class="input-group-append">
                      <span class="input-group-text">mg/gCr</span>
                    </div>
                  </div>
                </div>
                <div class="col-sm-1">
                  <b-form-checkbox class="mr-sm-2 mb-sm-2"></b-form-checkbox>
                </div>
              </div>

              <!-- <div class="row mb-1 align-items-center">
                <label for="" class="col-sm-4 col-form-label"
                  >SGLT2阻害薬</label
                >
                <div class="col-sm-6">
                  <b-form-select
                    id="inline-form-custom-select-pref"
                    :options="[
                      { text: '不明', value: null },
                      { text: '使用中', value: 1 },
                      { text: '未使用', value: 0 }
                    ]"
                    :value="null"
                    v-model="exams.SGLT2"
                  ></b-form-select>
                </div>
              </div>
              <div class="row mb-1 align-items-center">
                <label for="" class="col-sm-4 col-form-label">RAS阻害薬</label>
                <div class="col-sm-6">
                  <b-form-select
                    id="inline-form-custom-select-pref"
                    :options="[
                      { text: '不明', value: null },
                      { text: '使用中', value: 1 },
                      { text: '未使用', value: 0 }
                    ]"
                    :value="null"
                    v-model="exams.RAS"
                  ></b-form-select>
                </div>
              </div>
              <div class="row mb-1 align-items-center">
                <label for="" class="col-sm-4 col-form-label">MRB拮抗薬</label>
                <div class="col-sm-6">
                  <b-form-select
                    id="inline-form-custom-select-pref"
                    :options="[
                      { text: '不明', value: null },
                      { text: '使用中', value: 1 },
                      { text: '未使用', value: 0 }
                    ]"
                    :value="null"
                    v-model="exams.MRB"
                  ></b-form-select>
                </div>
              </div> -->
            </b-card-body>
            <div class="col right">
              <base-button icon type="primary" v-on:click="onClickPredict"
                >予測</base-button
              >
            </div>
          </b-card>
        </b-col>
        <b-col xl="8" md="6">
          <stats-card
            title="予測結果"
            type="gradient-orange"
            :sub-title="result_slope_text"
            icon=""
            class="mb-2"
          >
            <template slot="footer">
              <vue-loading
                v-show="isLoading"
                type="spiningDubbles"
                color="#2dce89"
                :size="{ width: '100px', height: '100px' }"
              >
              </vue-loading>
              <span v-show="!isLoading" class="text-nowrap">{{
                result_years_to_15_text
              }}</span>
            </template>
          </stats-card>
          <card type="white" header-classes="bg-transparent">
            <b-row align-v="center" slot="header">
              <b-col>
                <h5 class="h3 text-black mb-0">予測推移グラフ</h5>
              </b-col>
              <b-col> </b-col>
            </b-row>
            <vue-loading
              v-show="isLoading"
              type="spiningDubbles"
              color="#2dce89"
              :size="{ width: '100px', height: '100px' }"
            >
            </vue-loading>
            <div class="mb-2  px-5">
              <img :src="result" v-show="!isLoading" class="img-fluid" />
            </div>
          </card>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>
<script>
// Charts
import * as chartConfigs from "@/components/Charts/config";
import LineChart from "@/components/Charts/LineChart";

// Components
import BaseProgress from "@/components/BaseProgress";
import StatsCard from "@/components/Cards/StatsCard";

// Tables
import SocialTrafficTable from "./Dashboard/SocialTrafficTable";
import PageVisitsTable from "./Dashboard/PageVisitsTable";

import Axios from "axios";
import { VueLoading } from "vue-loading-template";

export default {
  components: {
    LineChart,
    BaseProgress,
    StatsCard,
    PageVisitsTable,
    SocialTrafficTable,
    VueLoading
  },
  data() {
    return {
      axios: Axios.create({
        headers: {
          "Content-Type": "application/json"
        }
      }),
      isLoading: false,
      result: "",
      result_slope: "",
      result_years_to_15: "",
      alertMessage: null,
      resultMessage: null,
      exams: {
        Baseline_eGFR: null,
        Serum_Creatinine: null,
        Plasma_Albumin: null,
        Serum_Sodium: null,
        Serum_Potassium: null,
        UP_Qualitative: null,
        UP_Quantitative: null,
        Diabetes: null,
        Hypertension: null,
        Gender: null,
        Age: null,
        SGLT2: null,
        RAS: null,
        MRB: null
      }
    };
  },
  computed: {
    result_slope_text() {
      if (this.result_years_to_15) {
        return `1年間でeGFRが${this.result_slope}減少`;
      } else {
        return "";
      }
    },
    result_years_to_15_text() {
      if (this.result_years_to_15) {
        return `eGFRが15未満（末期腎不全）になるまで約${this.result_years_to_15}年です`;
      } else {
        return "";
      }
    }
  },
  methods: {
    initBigChart(index) {
      let chartData = {
        datasets: [
          {
            label: "Performance",
            data: this.bigLineChart.allData[index]
          }
        ],
        labels: ["May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"]
      };
      this.bigLineChart.chartData = chartData;
      this.bigLineChart.activeIndex = index;
    },
    computeEgfr() {
      var eGFR = this.exams.Baseline_eGFR;
      if (this.exams.Gender == 0) {
        eGFR =
          194 *
          Math.pow(this.exams.Serum_Creatinine, -1.094) *
          Math.pow(this.exams.Age, -0.287) *
          0.739;
      } else if (this.exams.Gender == 1) {
        eGFR =
          194 *
          Math.pow(this.exams.Serum_Creatinine, -1.094) *
          Math.pow(this.exams.Age, -0.287);
      }
      this.exams.Baseline_eGFR = eGFR;
    },
    onExamUpdated(evt) {
      this.computeEgfr();
    },
    onClickPredict(item) {
      this.asyncPredictEgfr(this.exams);
    },
    asyncPredictEgfr(exams) {
      this.isLoading = true;
      var inputData = exams;
      var queryString = Object.keys(inputData)
        .map(key => key + "=" + inputData[key])
        .join("&");
      var inputDone = Object.values(inputData).every(x => x !== "");
      console.log(inputData);
      console.log(inputDone);
      if (inputDone) {
        (this.result_slope = " (計算中...) "),
          (this.result_years_to_15 = " (計算中...) "),
          this.axios
            .get("http://35.76.232.16:8080/predict_egfr_values?" + queryString)
            .then(
              function(response) {
                this.result_predictions = response.data.predictions;
                // [{"eGFR_Year_0":3,"eGFR_Year_1":16.8525,"eGFR_Year_2":14.6221,"eGFR_Year_3":16.041}]
                this.result_slope = response.data.slope;
                this.result_years_to_15 = response.data.years_to_15;

                this.alertMessage = null;
              }.bind(this)
            )
            .catch(err => {
              console.log(this.err);
              this.alertMessage = err;
            });
        this.axios
          .get("http://35.76.232.16:8080/predict_and_plot_egfr?" + queryString)
          .then(
            function(response) {
              this.result = "data:image/png;base64," + response.data;

              this.alertMessage = null;
              this.isLoading = false;
            }.bind(this)
          )
          .catch(err => {
            console.log(this.err);
            this.alertMessage = err;
            this.isLoading = false;
          });
      } else {
        this.alertMessage = "Fill in all variables";
        this.isLoading = false;
      }
    }
  },
  mounted() {}
};
</script>
<style>
.el-table .cell {
  padding-left: 0px;
  padding-right: 0px;
}
</style>
